import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// 라우트(경로)가 바뀔 때마다 스크롤을 페이지 최상단으로 이동
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
